export function isLineChart(options: Highcharts.Options): boolean {
  return options.chart.type === 'line';
}

export function isColumnChart(options: Highcharts.Options): boolean {
  return options.chart.type === 'column';
}

export function isBarChart(options: Highcharts.Options): boolean {
  return options.chart.type === 'bar';
}

export function isGroupedBarChart(options: Highcharts.Options): boolean {
  return isBarChart(options) && !Array.isArray(options.xAxis) && options.xAxis.categories?.length > 0 && options.xAxis.categories.every(category => category.includes('/'))
}

